// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"7cf977a1","230":"bcc0b243","305":"48ed9595","654":"f4d9cac5","810":"c6e9cd86","912":"9670904c"}[chunkId] + ".chunk.css";
};